module.exports = new __parcel__URL__("report-control-classic.fa1bb335.svg").toString();